<template class="rizwans">
  <v-app style="background: black">
    <postPing :articles="articles" :countryCode="countryCode" :countryName="countryName" :countryEmoji="countryEmoji" v-if="pingClicked"
    @closeWindow="closeWindow" @refresh-posts="refetchPosts" @open-profile="openProfile" />
    <navbar :drawer="!drawer" @country="country" @upload="handleUpload" @open-profile="openProfile" @fetch-posts="refetchPosts"
      @fetchTrendingNews="fetchTrendingNews()" :trendingNews="trendingNews" />
      <!--<observationPostPing @closeObservationPostWindow="closeObservationPostWindow" v-if="closeObservationPost" />-->
      <div id="myearth">
        <div id="atmos" height="100vh" width="100vw">
      </div>
      </div>
      <!--
        <div id="info" >
          Textures by NASA © 2025 RF. Triyangle. All Rights Reserved
        </div>
        -->
      <div id="controls">
        <div id="sun-slider-wrap">
          <input type="range" min="0" max="360" value="90" id="sun-slider">
        </div>
      </div>
    <uploadContent @upload="handleUpload" />
    <message-box 
    v-if="messageDialog"
      :initial-messages="[
        { from: 'other', text: 'Hello, how can I help you?' }
      ]"
      @message-sent="handleSend"/>
    <!-- PROFILE SHEET -->
    <v-bottom-sheet v-model="profileSheet"
      content-class="profile-sheet"
      :style="{ zIndex: 9999 }"
      class="overflow-auto pb-10"
      v-if="$vuetify.breakpoint.mdAndUp" 
      :width="profilePageWidth" :height="profilePageHeight">
      <v-card class="mx-auto text-left">
        <profilePage
          v-if="selectedUserId"
          :user-id="selectedUserId"
        />
      </v-card>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="profileSheet"
      :style="{ zIndex: 9999 }"
      class="overflow-auto pb-10"
      v-if="$vuetify.breakpoint.smAndDown" 
      :width="profilePageWidth" :height="profilePageHeight">
      <v-card class="mx-auto text-left">
        <profilePage
          v-if="selectedUserId"
          :user-id="selectedUserId"
        />
      </v-card>
    </v-bottom-sheet>
    <!--End Profile Sheet-->
  </v-app>
</template>
<script>
import axios from 'axios' // importing the axios (a HTTP library) to connects the app with the News API
import { mapState } from 'vuex'
import navbar from './components/navbar'
import uploadContent from './components/uploadContent'
import postPing from './components/postPing'
import messageBox from './components/messageBox'
import profilePage from './components/profilePage.vue'
// import observationPostPing from './components/observationPostPing'
import { apiUrl } from './config';

export default {
  name: 'Globe',
  components: {
    postPing,
    navbar,
    messageBox,
    uploadContent,
    profilePage,
    // observationPostPing,
  },
  //
  computed: {
    ...mapState({
      messageDialog: state => state.isDialogOpen   // map state to computed
    }),
    // Profile page dimension based on screen size
		//
		profilePageHeight() {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs': return 800;
				case 'sm': return 800;
				case 'md': return 800;
				case 'lg': return 800;
				case 'xl': return 1600;
				default: return 800; // Default value if no case matches
			}
		},
		profilePageWidth() {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs': return 400;
				case 'sm': return 400;
				case 'md': return 1200;
				case 'lg': return 1200;
				case 'xl': return 1800;
				default: return 1200; // Default value if no case matches
			}
		},
  },
  data() {
    return {
      drawer: false, // false = Vuetify automatically "do the right thing" to show/hide the drawer
      api_key: '655326592290456dadb28005bbd8f70b', // Your API Key go here
      articles: [],
      dialog: true,
      trendingNews: [],
      showTrendingNews: false,
      errors: [],
      pingClicked: false,
      closeObservationPost: true,
      countryName: '',
      countryCode: '',
      marker: {},
      API_URL: apiUrl,
      profileSheet: false,
      selectedUserId: null,
    }
  },
  // For UserId coming from the profilePage.vue
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      var myearth;
      var sunAngle = 70;
      var activeHotspot;

      var updateMapTimer = false;
      var lightMask, lightMaskCtx, lightGradient;

      // Will be executed when the DOM is ready

      myearth = new Earth('myearth', {

        //location: { lat: 10, lng: -74 },
        location: { lat: 15, lng: 30 },  
        sunLocation: { lat: 0, lng: 360 - sunAngle },
        zoom: 0.925,

        dragPolarLimit: 0.8,

        light: 'sun',
        shadows: false,
        lightAmbience: 0.8,
        shininess: 0.14,
        

        autoRotate: true,
        autoRotateSpeed: 1,
        /*
        autoRotateDelay: 0,
        autoRotateStart: 2000,
        */
      });

      // After 7 seconds, stop rotation and move to Africa
      setTimeout(function () {
        myearth.autoRotate = false; // stop spin
        // Smoothly animate camera to Africa
        myearth.gotoLocation({ lat: 0, lng: 20 }, 2000);  // 2000ms = 2s
      }, 7000); // let it spin for 5 seconds


      myearth.addEventListener("ready", function () {

        //this.startAutoRotate();


        // add random stars

        var star_count = 900;

        for (var i = 0; i < star_count; i++) {

          this.addSprite({
            location: { lat: getRandomInt(-50, 50), lng: getRandomInt(-180, 180) },
            offset: getRandomInt(40, 50),
            scale: 0.25,
            opacity: getRandomInt(25, 80) / 100
          });

        }


        // equator

        var equator = this.addLine({
          locations: [
            { lat: 0, lng: 0 },
            { lat: 0, lng: 179.999 },
            { lat: 0, lng: -0.01 }
          ],
          color: 0xffcd42,
          offset: 0.05,
          hairline: true,
          clip: 0
        });


        var equatorLabel = this.addOverlay({
          location: { lat: 1.5, lng: 0 },
          offset: 0.1,
          content: '<span style="color:#ffcd42"><strong>Equator</strong> <br> Length: 40,075 km</span>',
          depthScale: 0.4,
          visible: false,
          className: 'label',
        });

        var equatorHotspot = this.addOverlay({
          location: { lat: 0, lng: 0 },
          depthScale: 0.4,
          className: 'hotspot',
        });

        equatorHotspot.element.addEventListener('click', function () {

          if (activeHotspot) activeHotspot.reverse();

          equatorHotspot.visible = false;

          equator.animate('clip', 1, {
            easing: 'linear', duration: 1000, complete: function () {
              equatorLabel.visible = true;
            }
          });

          activeHotspot = equatorHotspot;

        });

        equatorHotspot.reverse = function () {

          equatorLabel.visible = false;

          equator.animate('clip', 0, {
            easing: 'linear', duration: 500, complete: function () {
              equatorHotspot.visible = true;
            }
          });

        };

        // Lalibela Ethiopia

        var lineOptions = {
          locations: [
            { lat: 12.03333, lng: 39.03333 },
            { lat: 9.03333, lng: 39.03333 }
          ],
          color: 0xf24e06,
          offsetFlow: 1,
          offsetEasing: 'in-quad',
          hairline: true,
          clip: 0
        };

        var lalibela1 = this.addLine(lineOptions);

        lineOptions.locations[0] = { lat: 7.03333, lng: 35.03333 };
        var lalibela2 = this.addLine(lineOptions);

        lineOptions.locations[0] = { lat: 10.03333, lng: 43.03333 };
        var lalibela3 = this.addLine(lineOptions);


        var lalibelaLabel = this.addOverlay({
          location: { lat: 12.03333, lng: 39.03333 },
          offset: 0.5,
          content: '<span style="color:#f24e06"><strong>Lalibela</strong> <br> lat: 12.033 lng: 39.033<br> <a href="https://whc.unesco.org/en/list/18/" target="_blank">Click here to learn more',
          depthScale: 0.4,
          visible: false,
          className: 'label',
        });

        var lalibelaHotspot = this.addOverlay({
          location: { lat: 12.03333, lng: 39.03333 },
          offset: 0.8,
          depthScale: 0.4,
          className: 'hotspot',
        });

        lalibelaHotspot.element.addEventListener('click', function () {

          if (activeHotspot) activeHotspot.reverse();

          lalibelaHotspot.visible = false;

          lalibela1.animate('clip', 1, { duration: 700 });
          lalibela2.animate('clip', 1, { duration: 700 });
          lalibela3.animate('clip', 1, {
            duration: 700, complete: function () {
              lalibelaLabel.visible = true;
            }
          });

          activeHotspot = lalibelaHotspot;

          // Set the ping to reatract
          //
          function retractLabel() {
            // lalibelaLabel.visible = false;
            lalibelaHotspot.visible = true;

          } // End
        });


        lalibelaHotspot.reverse = function () {

          lalibelaLabel.visible = false;

          lalibela1.animate('clip', 0, { duration: 10 });
          lalibela2.animate('clip', 0, { duration: 10 });
          lalibela3.animate('clip', 0, {
            duration: 10, complete: function () {
              lalibelaHotspot.visible = true;
            }
          });

        };

        /***End of Lalibela***/

        // mount everrest

        var lineOptions = { 
          locations: [
            { lat: 30.991, lng: 86.892 },
            { lat: 27.991, lng: 86.892 }
          ],
          color: 0xf24e06,
          offsetFlow: 1,
          offsetEasing: 'in-quad',
          hairline: true,
          clip: 0
        };

        var everest1 = this.addLine(lineOptions);

        lineOptions.locations[0] = { lat: 25.991, lng: 82.892 };
        var everest2 = this.addLine(lineOptions);

        lineOptions.locations[0] = { lat: 25.991, lng: 90.892 };
        var everest3 = this.addLine(lineOptions);


        var everestLabel = this.addOverlay({
          location: { lat: 27.991, lng: 86.892 },
          offset: 1,
          content: '<span style="color:#f24e06"><strong>Mount Everest</strong> <br> Elevation: 8,848 m  </span> <br> <a href="https://www.britannica.com/place/Mount-Everest" target="_blank">Learn more about Mount Everest</a>',
          depthScale: 0.4,
          visible: false,
          className: 'label',
        });

        var everestHotspot = this.addOverlay({
          location: { lat: 27.991, lng: 86.892 },
          offset: 0.8,
          depthScale: 0.4,
          className: 'hotspot',
        });

        everestHotspot.element.addEventListener('click', function () {

          if (activeHotspot) activeHotspot.reverse();

          everestHotspot.visible = false;

          everest1.animate('clip', 1, { duration: 700 });
          everest2.animate('clip', 1, { duration: 700 });
          everest3.animate('clip', 1, {
            duration: 700, complete: function () {
              everestLabel.visible = true;
            }
          });

          activeHotspot = everestHotspot;

          // Set the ping to reatract
          //
          function retractLabel() {
            // everestLabel.visible = false;
            everestHotspot.visible = true;

          } // End
        });


        everestHotspot.reverse = function () {

          everestLabel.visible = false;

          everest1.animate('clip', 0, { duration: 10 });
          everest2.animate('clip', 0, { duration: 10 });
          everest3.animate('clip', 0, {
            duration: 10, complete: function () {
              everestHotspot.visible = true;
            }
          });

        };
        // My function
        /****************************************/

        /******************************************/


        // mariana trench

        var mariana = this.addLine({
          locations: [
            { lat: 11, lng: 144 },
            { lat: 11.4, lng: 145.9 },
            { lat: 12.2, lng: 147.8 },
            { lat: 14.0, lng: 149.0 },
            { lat: 15.9, lng: 149.5 },
            { lat: 17.5, lng: 149.2 },
            { lat: 19.0, lng: 148.1 },
            { lat: 21.2, lng: 147.2 },
            { lat: 22.6, lng: 147.4 }
          ],
          color: 0x0066ff,
          hairline: true,
          clip: 0
        });


        var marianaLabel = this.addOverlay({
          location: { lat: 18, lng: 158 },
          offset: 0,
          content: '<span style="color:#0066ff"><strong>Mariana Trench</strong> <br> Depth: 11,034 m</span>',
          depthScale: 0.4,
          visible: false,
          className: 'label',
        });

        var marianaHotspot = this.addOverlay({
          location: { lat: 15.6, lng: 158 },
          depthScale: 0.4,
          className: 'hotspot',
        });


        marianaHotspot.element.addEventListener('click', function () {

          if (activeHotspot) activeHotspot.reverse();

          marianaHotspot.visible = false;

          mariana.animate('clip', 1, {
            duration: 800, complete: function () {
              marianaLabel.visible = true;
            }
          });

          activeHotspot = marianaHotspot;

        });

        marianaHotspot.reverse = function () {

          marianaLabel.visible = false;

          mariana.animate('clip', 0, {
            duration: 400, complete: function () {
              marianaHotspot.visible = true;
            }
          });

        };



        // amazon

        var amazon = this.addLine({
          locations: [
            { lat: -15.518, lng: -71.765 },
            { lat: -14.98, lng: -71.78 },
            { lat: -13.53, lng: -73.88 },
            { lat: -8.65, lng: -74.73 },
            { lat: -6.42, lng: -74.12 },
            { lat: -5.07, lng: -73.21 },
            { lat: -3.574, lng: -71.86 },
            { lat: -3.78, lng: -69.55 },
            { lat: -3.064, lng: -67.05 },
            { lat: -2.664, lng: -65.36 },
            { lat: -4.0, lng: -63.65 },
            { lat: -3.494, lng: -60.0 },
            { lat: -3.393, lng: -57.46 },
            { lat: -2.385, lng: -55.17 },
            { lat: -2.277, lng: -53.8 },
            { lat: -1.483, lng: -51.69 },
            { lat: 0.4687, lng: -48.506 }
          ],
          color: 0x009ee5,
          hairline: true,
          clip: 0
        });

        var amazonLabel = this.addOverlay({
          location: { lat: -8.5, lng: -61.4 },
          content: '<span style="color:#009ee5;"><strong>Amazon</strong> <br> Discharge: 206,000 m³/s</span>',
          depthScale: 0.4,
          visible: false,
          className: 'label',
        });

        var amazonHotspot = this.addOverlay({
          location: { lat: -15.518, lng: -71.765 },
          depthScale: 0.4,
          className: 'hotspot',
        });

        amazonHotspot.element.addEventListener('click', function () {

          if (activeHotspot) activeHotspot.reverse();

          amazonHotspot.visible = false;

          amazon.animate('clip', 1, {
            duration: 900, complete: function () {
              amazonLabel.visible = true;
            }
          });

          activeHotspot = amazonHotspot;

        });

        amazonHotspot.reverse = function () {

          amazonLabel.visible = false;

          amazon.animate('clip', 0, {
            duration: 450, complete: function () {
              amazonHotspot.visible = true;
            }
          });

        };


        prepareLightMask();
        updateMapTexture();


      });


      document.getElementById("sun-slider").addEventListener('input', function () {
        sunAngle = this.value;
        myearth.sunLocation = { lat: 0, lng: 360 - this.value };

        // limit redraws
        if (updateMapTimer) return;
        updateMapTimer = setTimeout(updateMapTexture, 100);

      });



      // setTimeout(retractLabel, 3000);



      function prepareLightMask() {

        lightMask = document.createElement('canvas');
        lightMaskCtx = lightMask.getContext('2d');

        var w = myearth.mapCanvas.width, h = myearth.mapCanvas.height;

        lightMask.width = w * 2;
        lightMask.height = h;

        lightGradient = lightMaskCtx.createRadialGradient(
          w / 2, h / 2, h * 0.38,
          w / 2, h / 2, w * 0.28,
        );

        lightGradient.addColorStop(0, "RGBA(0,0,0,1)");
        lightGradient.addColorStop(1, "RGBA(0,0,0,0)");

      }


      function updateMapTexture() {

        updateMapTimer = false;

        var w = myearth.mapCanvas.width, h = myearth.mapCanvas.height;

        // night background
        var nightImg = document.getElementById('night');
        myearth.mapContext.drawImage(nightImg, 0, 0, nightImg.width, nightImg.height, 0, 0, w, h);

        var offset = sunAngle / 360 * w;

        lightMaskCtx.clearRect(0, 0, w * 2, h);
        lightMaskCtx.globalCompositeOperation = 'source-over';
        lightMaskCtx.fillStyle = lightGradient;
        lightMaskCtx.fillRect(0, 0, w, h);
        lightMaskCtx.drawImage(lightMask, 0, 0, w, h, w, 0, w, h);


        var dayImg = document.getElementById('day');
        lightMaskCtx.globalCompositeOperation = 'source-in';
        lightMaskCtx.drawImage(dayImg, 0, 0, dayImg.width, dayImg.height, offset, 0, w, h);

        myearth.mapContext.drawImage(lightMask, offset, 0, w, h, 0, 0, w, h);

        myearth.updateMap();

      }

      function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min;
      }


    })
  },
  watch: {
    articles(newVal, oldVal) {
      // Watch for changes in the updatedValue and perform additional actions if needed
      console.log('articles has changed: old value', oldVal);
      console.log('articles has changed: new value', newVal);
    },
    userId: {
      immediate: true,
      handler() {
        if (this.userId) {
          this.getProfileData()
        }
      }
    },
  },
  methods: {
    	async getProfileData() {
			  try {
          let user = localStorage.getItem('user');
          user = JSON.parse(user);

          const token = user.access;

          const payload = JSON.parse(atob(token.split('.')[1]));

          const userId = payload.user_id;
          const response = await axios.get(
				  `${this.API_URL}posts/users/${userId}/`,
				{
					headers: {
					Authorization: 'Bearer ' + JSON.parse(
						localStorage.getItem('user')
					).access
					}
				})
				this.profileData = response.data

			} catch (error) {
				console.error('Error loading profile:', error)
			}
		},
    // OPen the profile page when the user clicks on a profile picture or name
    openProfile(userId) {
      console.log('Opening profile:', userId)

      this.selectedUserId = userId
      this.profileSheet = true
    },
    // Handle the upload event from the uploadContent component
    async handleUpload(e) {
      //console.log("inside app.vue");
      this.countryName = e.country.name;
      this.countryCode = e.country.country_code;
      this.countryEmoji = e.country.emoji
      //await this.fetchArticles();
      let lat = e.country.latlng[0];
      let lng = e.country.latlng[1];
      let location = { lat, lng };
      this.addTempOverlay(location);
      var tempArticle = {
        author: "Ridge Francis",
        content: e.uploadedText,
        publishedAt: Date.now(),
        title: e.uploadedText,
        url: e.uploadedLink,
        source: { name: "Ridge Francis" },
      };
      this.articles.push(tempArticle);
      console.log(this.articles);
    },

    addTempOverlay(location) {
      var myearth = document.getElementById("myearth").earth;
      myearth.location = location;
      var overlay = myearth.addOverlay({
        location: location,
        offset: 1,
        content:
          '<span style="color:white; margin-top: 80px;"><strong>' +
          this.countryName +
          "</strong></span>",
        depthScale: 0.4,
        color: "red",
        visible: true,
        className: "country",
      });
      var _this = this;
      overlay.element.addEventListener("click", function () {
        _this.pingClicked = true;
      });
      setTimeout(function () {
        overlay.remove();
      }, 100000);
    },
    country(country) {
      this.countryName = country.name
      this.countryCode = country.country_code
      this.countryEmoji = country.emoji
      this.fetchArticles()
      let lat = country.latlng[0]
      let lng = country.latlng[1]
      let location = { lat, lng }
      this.addSpriteAndOverlay(location)
    },
    refetchPosts() {
      console.log('refetch triggered')
      this.fetchArticles()
    },
    fetchArticles() {
      let user = localStorage.getItem('user')
      user = JSON.parse(user)

      const authToken = 'Bearer ' + user['access'];
      console.log(authToken)
      console.log(this.countryName)
      axios
        .get(
          `${this.API_URL}posts/?search=${this.countryName}`, {
          headers: {
            'Authorization': authToken,
          },                                                                                                    
        })
        .then((response) => {
          //console.log(response.data)
          //console.log(typeof (response.data))
          //this.articles = response.data.articles
          this.articles = response.data
          console.log('data:')
          console.log(response.data) // This will give you access to the full object
          console.log(typeof (response.data)) // This will give you access to the full object
        })
        .catch((e) => {
          this.errors.push(e)
        })
    },
    fetchTrendingNews() {
      axios
        .get(
          'https://newsapi.org/v2/top-headlines?country=us&apiKey=' + this.api_key,
        )
        .then((response) => {
          this.trendingNews = response.data.articles
          console.log(response.data.articles) // This will give you access to the full object
        })
        .catch((e) => {
          this.errors.push(e)
        })
    },
    toggleTrendingNews() {
      return this.showTrendingNews = !this.showTrendingNews
    },
    addSpriteAndOverlay(location) {
      var myearth = document.getElementById('myearth').earth
      myearth.location = location
      var overlay = myearth.addOverlay({
        location: location,
        offset: 1,
        content:
          '<span style="color:white; margin-top: 80px;"><strong>' +
          this.countryName +
          '</strong></span>',
        depthScale: 0.4,
        color: 'red',
        visible: true,
        className: 'country',
      })

      var _this = this
      overlay.element.addEventListener('click', function () {
        _this.pingClicked = true;
      })
    },
    closeWindow() {
      let overlays = document.getElementById('myearth').earth.overlays
      this.pingClicked = false
      overlays.forEach(overlay => {
        if (overlay["color"] == "red") {
          overlay.remove();
        }
      })
    },
    closeObservationPostWindow() {
      if (this.closeObservationPost == true) {
        this.closeObservationPost = false
      }
    },
  }
}
</script>
